const whiteLabelThemeScript = document.createElement('link');
whiteLabelThemeScript.setAttribute('rel', 'stylesheet');
whiteLabelThemeScript.setAttribute('type', 'text/css');

const whiteLabelFavIconScript = document.createElement('link');
whiteLabelFavIconScript.setAttribute('rel', 'shortcut icon');

const { hostname } = window.location;
//eslint-disable-next-line
let whiteLabelConfig;
if (window.webconfig) {
    whiteLabelConfig = window.webconfig.find((config) => config.domain === hostname);
}
document.title = 'Bloomlink';
whiteLabelFavIconScript.setAttribute('type', 'image/ico');
document.getElementsByTagName('head')[0].appendChild(whiteLabelThemeScript);
document.getElementsByTagName('head')[0].appendChild(whiteLabelFavIconScript);
